<app-card-table
    translatePrefix="database.organizationAdministrationPage.statutoryRepresentative.table."
    [tableTitle]="'database.organizationAdministrationPage.statutoryRepresentative.table.title'"
    [columns]="columns"
    [showDetail]="isAllowed['organization.update']()"
    [showDelete]="isAllowed['organization.update']()"
    [gridData]="$any(store.data.getOrganizationCenterPersons())"
    [refreshCallback]="store.api.getOrganizationCenterPersons"
    [refreshCallbackFragment]="getPersonsFrag"
    [additionalFilter]="additionalFilter()"
    [buttons]="buttons"
    (createCallback)="upsertContactPersonDialog()"
    (detailCallback)="upsertContactPersonDialog($event)"
    (deleteCallbackWithEvent)="unlinkPerson($event)"
    [defaultSorters]="[{ column: 'validFrom', direction: 'DESC' }]"
>
    <ng-template pTemplate="name" let-data="data">
        {{ data | formatPerson }}
    </ng-template>

    <ng-template pTemplate="validFrom" let-data="data">
        {{ data | shortDate }}
    </ng-template>

</app-card-table>

<ng-template #buttons>
    <app-button
        icon="pi-user"
        [pTooltip]="'database.organizationAdministrationPage.statutoryRepresentative.primaryStatutoryRepresentativeButtonTitle' | translate"
        (clickEvent)="contactSelectDialog()"
    ></app-button>
</ng-template>
